import { useEffect, useState } from "react";
import ErrorLogout from "../../../helpers/ErrorLogout";
import { Table } from "antd";
import moment from "moment";
import { getTransactionHistory } from "../../../api/AdminRequest";

function TransactionHistory({ buyerID }) {

  const [transactions, setTransactions] = useState([]);
  const [loader, setLoader] = useState([]);

  useEffect(() => {
    const transactionCall = async () => {
      try {
        setLoader(true);
        const { data } = await getTransactionHistory(buyerID);
        if (data?.success) {
          setTransactions(data?.buyerTransactions);
          setLoader(false);
        } else {
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);

        console.log(error);
        console.log(error.message);
        if (error?.response?.status === 401) {
          ErrorLogout(error);
        }
      }
    };
    transactionCall();
  }, [buyerID]);

  const column = [
    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">Sl.No</span>
      ),
      dataIndex: "_id",
      render: (text, record, index) => (
        <span className="text-[#878787] text-[16px] font-medium">
          {index + 1}
        </span>
      ),
      align: "center",
    },
    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">
          Transaction ID
        </span>
      ),
      dataIndex: "_id",
      render: (_id) => (
        <span className="text-[##313131] text-[16px] font-semibold">{_id}</span>
      ),
      align: "center",
    },

    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">Date</span>
      ),
      dataIndex: "createdDate",
      render: (createdDate) => (
        <span className="text-[#878787] text-[16px] font-medium">
          {moment(createdDate).format("DD/MM/YYYY HH:MM")}
        </span>
      ),
      align: "center",
    },
    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">Type</span>
      ),
      dataIndex: "type",
      align: "center",
      render: (type) => (
        <>
          <span className="text-[#878787] text-[16px] font-medium">{type}</span>
        </>
      ),
    },
    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">Amount</span>
      ),
      dataIndex: "status._id",
      render: (status, _id) =>
        _id.type === "debit" ? (
          <h1 className="text-[16px] text-[#FF4545] font-semibold">
            -{_id?.amount}
          </h1>
        ) : (
          <h1 className="text-[#01A208]  text-[16px] font-semibold">
            +{_id?.amount}
          </h1>
        ),
      align: "center",
    },

    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">Actions</span>
      ),
      dataIndex: "status._id",
      align: "center",
      render: () => (
        <>
          <div className="gap-2">
            <button className="cursor-pointer bg-transparent border-[1px] border-[#1955EB] text-[#1955EB] rounded w-32 font-semibold px-3 py-2 mr-2">
              View Details
            </button>
          </div>
        </>
      ),
    },
  ];

  return (
    <div className="container">
      <div className="shadow-lg hover:shadow-xl rounded-xl mt-4 overflow-x-auto">
        <Table
          className="min-w-full divide-y divide-gray-200"
        //   pagination={{
        //     total: transactions?.length,
        //     showTotal: (total, range) =>
        //       `Showing ${range[0]} to ${range[1]} of ${total} entries`,
        //     showSizeChanger: true,
        //     onShowSizeChange: onShowSizeChange,
        //     itemRender: itemRender,
        //   }}
          columns={column}
          loading={loader}
          dataSource={transactions}
          rowKey={(record) => record.id}
        />
      </div>
    </div>
  );
}

export default TransactionHistory;
